export class CharacterCounter {
    private _currentContext: JQuery = null;
    private _max: number = 0;
    private _label: JQuery = null;
    private _input: JQuery = null;

    private bindEvents(): void {
        this._input.on("keyup", () => this.updateLabelValue());
    }

    private parseContext(): void {
        this._label = $(".js-pcg-counter", this._currentContext);
        this._input = $(".js-pcg-input-for-counter", this._currentContext);
    }

    private updateLabelValue(): void {
        const count = this._max - this._input.val().toString().length;
        this._label.text(`Max ${this._max} characters. remaining ${Math.max(0, count)}`);
    }

    public init(context: JQuery, maxCharactersCount: number): void {
        this._currentContext = context || this._currentContext;
        this._max = maxCharactersCount || this._max;

        this.parseContext();
        this.bindEvents();
        this.updateLabelValue();
    }

    public static init(context: JQuery, maxCharactersCount: number): CharacterCounter {
        const component = new CharacterCounter();
        component.init(context, maxCharactersCount);
        return component;
    }
}
